<template>
  <div class="bg-white rounded mx-4">
    <div class="row mb-3" v-if="!showNotResults">
      <div class="col-12">
        <p class="text-muted">Nombre de documento:</p>
      </div>
    </div>
    <custom-result-not-found
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No hay Información Disponible."
    />
    <div v-else v-for="document in documentsUsage" :key="document.id">
      <div class="row mb-3">
        <div class="col-12 col-lg-6">
          <p class="font-16 fw-400">
            Garantia Uso e Inventario - {{ document.peiIdFormatted }}
          </p>
        </div>
        <div class="col-12 col-lg-6 d-flex justify-content-end">
          <action-button
            id="btnShowDocument"
            i="fas fa-file-search"
            text="Ver Documento"
            variant="outline-success px-3"
            @click="downloadDocument(document)"
          />
        </div>
      </div>
    </div>
    <div class="row border-top mt-5 pt-3">
      <div class="col-12">
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';

import referralService from '@/services/api/referralsandequipments.api';
import reportService from '@/services/api/report.api.js';

export default {
  name: 'EquipmentUseInventoryDocuments',
  components: {
    ActionButton,
    Pagination,
    CustomResultNotFound,
  },
  props: {
    referral: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    documentsUsage: [],
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 5,
    },
  }),
  computed: {
    showNotResults() {
      return this.documentsUsage.length === 0;
    },
  },
  mounted() {
    this.getDocumentsUsage();
  },
  methods: {
    onPageChange(page) {
      this.pagination.currentPage = page;
      this.getDocumentsUsage();
    },
    async getDocumentsUsage() {
      const id = this.referral.id;
      const { data } = await referralService.getEquipmentUsageGuaranteeDocument(
        {
          peiAtServiceId: id,
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        }
      );
      this.pagination.totalItemCount = data.totalItemCount;
      this.pagination.count = data.count;
      this.pagination.pageCount = data.pageCount;
      this.documentsUsage = data.data;
    },
    async downloadDocument(document) {
      const peiId = parseInt(document.peiId);
      await reportService.downloadUsageGuaranteeDocumentReport({
        peiId,
        studentSieId: this.referral.sieId,
        peiAtServiceId: this.referral.id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.fw-400 {
  font-weight: 400;
}
</style>
